import { Button } from '@mui/material';
import Image from 'next/image';
import { ZALO_OA_SUPPORT } from '../../../configs/externalLink';
import { ZaloIcon } from '../../../constant/imgImport';
import { DOCCEN_CARE_GMAIL_PRE_COMPOSE_URL } from '../../../constant/payment';
import { OutlinedCallIcon, OutlinedMailIcon } from '../svgIcon/outlined';

function PurchaseContactSection() {
  return (
    <div className="flex flex-col items-center justify-between md:flex-row">
      <div className="h-full flex-shrink-0">
        <Button
          onClick={() => window.open(ZALO_OA_SUPPORT)}
          variant="low_emphasis_v1"
          className="!gap-2 !py-[6px] !text-sm !font-medium !leading-4 !tracking-[-0.1px]"
        >
          <Image src={ZaloIcon} alt="zalo icon" width={20} height={20} />
          Liên hệ hỗ trợ
        </Button>
      </div>
      <div className="h-full flex-shrink-0">
        <Button
          variant="low_emphasis_v1"
          className="!gap-2 !py-[6px] !text-sm !font-medium !leading-4 !tracking-[-0.1px]"
          component="a"
          href="tel:+0949138929"
        >
          <OutlinedCallIcon width={20} height={20} />
          0949.138.929 (Mr. Khánh)
        </Button>
      </div>
      <div className="h-full flex-shrink-0">
        <Button
          onClick={() => window.open(DOCCEN_CARE_GMAIL_PRE_COMPOSE_URL)}
          variant="low_emphasis_v1"
          className="!gap-2 !py-[6px] !text-sm !font-medium !leading-4 !tracking-[-0.1px]"
        >
          <OutlinedMailIcon width={20} height={20} />
          cs@doccen.vn
        </Button>
      </div>
    </div>
  );
}

export default PurchaseContactSection;
